//Schichtlimitierung Planungsregel 46

function checkShiftlimitation(sFehler, iOffset, iWeeks, iAZeitenFT, isShiftlimitationSet){
    var error = "";
    if(isShiftlimitationSet === 1){
        var shiftlimitation = new Array();
        var shiftlimitationsArrayFromPHP = JSON.parse(document.getElementById("shiftlimitation").innerHTML);

        for(let i = 0; i < shiftlimitationsArrayFromPHP.length; i++){
            let shiftLimitationObject = ({
                offset: iOffset
                , weeks: iWeeks
                , ignoreAOnPublicHoliday: iAZeitenFT
                , name: shiftlimitationsArrayFromPHP[i]['name']
                , time: shiftlimitationsArrayFromPHP[i]['time']
                , numberOfShifts: shiftlimitationsArrayFromPHP[i]['numberOfShifts']
                , maximal: shiftlimitationsArrayFromPHP[i]['maximal']
                , after: shiftlimitationsArrayFromPHP[i]['after']
                , days: shiftlimitationsArrayFromPHP[i]['days']
                , publicHolidayAsWorkingDay: shiftlimitationsArrayFromPHP[i]['publicHolidayAsWorkingDay']
                , isSumSingleDaysOverAllWeeks: shiftlimitationsArrayFromPHP[i]['isSumSingleDaysOverAllWeeks']
                , perCalenderWeek: shiftlimitationsArrayFromPHP[i]['kalenderwoche']
                , timeUntil: shiftlimitationsArrayFromPHP[i]['timeUntil']
            });
            shiftlimitation[i] = new Shiftlimitation(shiftLimitationObject);
            error = error + shiftlimitation[i].compareShiftlimitation();
        }
    }
    if(error.length > 0 && sFehler.length > 0){
        error = sFehler + "<br />" + error;
    } else if(error.length > 0 && sFehler.length == 0){
        error = error;
    } else{
        error = sFehler;
    }
    return error;
}
